// /client/src/components/RewardsContent.js
import React from "react";
import { Link } from 'react-router-dom';
import "./AboutContent.css";

const RewardsContent = ({
    className,
    title,
    subtitle,
    body,
    cta,
    buttonLabel,
    link,
    linkUrl,
    imageUrl,
    colorMode,
}) => {

    const cardData = [
        {
            headline: "How It Works",
            subtitle: "Earn 1 punch of your Frequent Buyer Card for every Entrée purchased. Earn 1 Point on every $1 spent on everything else (including raw meat purchases and caterings)!"
        },
        {
            headline: "What You Can Earn",
            subtitle: "For every 12 Punches of your Frequent Buyer Card, you earn a Free Entrée.  For every 300 points, you earn a $15 Voucher that can be redeemed on any purchase."
        },
        {
            headline: "How to Redeem",
            subtitle: "Every visit, log in with your phone number at checkout to earn Punches and Points on your purchase. If you would like to redeem a reward, let your cashier know. ",
            link: {
                text: "Login here",
                url: "https://kindersmeats.comosense.net/auth/signin"
            },
            additionalText: " to see how close you are to earning rewards."
        }
    ];

    return (
        <>
            <div className={`column content-space-160 is-flex is-flex-direction-column ${className}`}>
                <div className="m-0 p-0 columns is-gapless is-variable is-flex is-justify-content-center">
                    {/* Photo widget on the right */}
                    <div className="m-0 p-0 column is-6">
                        <div className="m-0 p-0">
                            {/* Main image */}
                            {imageUrl && (
                                <div className="m-0 p-0 main-image">
                                    <img 
                                        src={imageUrl} 
                                        alt="Kinder's Rewards"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="column is-flex is-flex-direction-column is-justify-content-center is-4">
                        <div className="is-flex is-flex-direction-column">
                            <h1 className={`h1 ${colorMode}`}>{title}</h1>
                            <h2 className={`careers ${colorMode}`}>{subtitle}</h2>
                            <p className={`mt-1 careers ${colorMode}`}>{body}</p>
                            <p className="mt-3 careers is-bold colorGreen">{cta}</p>
                        </div>
                        <div className="mt-5 is-flex is-flex-direction-row is-flex-wrap-wrap is-align-items-center content-space-50-mobile-bottom">
                            <div> 
                                {/* Button added here */}
                                {buttonLabel && linkUrl && (
                                    <Link 
                                        to={linkUrl}
                                        className="button fullWidth"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {buttonLabel}
                                    </Link>
                                )}
                            </div>
                            <div className="ml-4 mt-4">
                                {link}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Cards Section */}
            <div className={`py-6 my-0 column is-flex is-flex-direction-column ${className}`}>
                <div className="columns is-centered is-multiline is-variable is-8">
                    {cardData.map((card, index) => (
                        <div key={index} className="m-0 py-2 column">
                            <div className="m-0 benefits-card">
                                <h4 className="mb-3 p-0 benefitCard is-align-center">{card.headline}</h4>
                                <p className="m-0 p-0 is-align-center">
                                    {card.subtitle}
                                    {card.link && (
                                        <>
                                            <a 
                                                href={card.link.url} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                style={{ color: '#007bff', textDecoration: 'underline' }}
                                            >
                                                {card.link.text}
                                            </a>
                                        </>
                                    )}
                                    {card.additionalText}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default RewardsContent;